import React from "react";
import PageRenderer from "../components/PageRender";

const DiventaPartner = () => {
  return <PageRenderer pageIdentifier="approccio" />;
};

export default DiventaPartner;
